// Copyright (c) 2021, Oracle and/or its affiliates. All rights reserved.
// Licensed under the Universal Permissive License v 1.0 as shown at http://oss.oracle.com/licenses/upl.
define('ProductDetails.GridOrder.SS2Model', [
    'SCModel',
    'Utils'
], function (
    SCModelModule,
    Utils
) {
    'use strict';
 
    var SCModel = SCModelModule.SCModel;
 
    function ProductDetailsGridOrderSS2Model (model, options) {
        SCModel.call(this, model, options);
 
        this.urlRoot = function urlRoot () {
            return Utils.getAbsoluteUrl(
                getExtensionAssetsPath(
                    'Modules/Main/SuiteScript2/ProductDetails.GridOrder.Service.ss'
                ), true
            )
        }
    }
	
	ProductDetailsGridOrderSS2Model.prototype = Object.create(SCModel.prototype);
    ProductDetailsGridOrderSS2Model.prototype.constructor = ProductDetailsGridOrderSS2Model;
    
    return ProductDetailsGridOrderSS2Model
})
